export default {
  state: {
    errorMessage: null
  },
  mutations: {
    showError(state, payload) {
      state.errorMessage = payload.message;
    }
  },
  actions: {
    dismissError({commit}) {
      commit('showError', {message: null});
    }
  },
  getters: {
      errorMessage(state) {
        return state.errorMessage;
      }
  }
}